import { render } from "./KycRestriction.vue?vue&type=template&id=00d55898&scoped=true"
import script from "./KycRestriction.vue?vue&type=script&lang=js"
export * from "./KycRestriction.vue?vue&type=script&lang=js"

import "./KycRestriction.vue?vue&type=style&index=0&id=00d55898&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d55898"]])

export default __exports__